import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { checkLicense as restCheckLicense } from '~/api/runtimeService';

type CheckLicenseVariables = {
  realm: string;
  environment: string;
  pipelineId: string;
  size: string;
  replicas: number;
  replicaInstanceName?: string;
};

export const useCheckLicense = () => {
  const queryClient = useQueryClient();

  const checkLicense = useCallback(
    (variables: CheckLicenseVariables) =>
      queryClient.fetchQuery({
        queryKey: [
          'run',
          'checkLicense',
          variables.realm,
          variables.environment,
          variables.pipelineId,
          variables.size,
          variables.replicas,
          variables.replicaInstanceName
        ],
        queryFn: async () => ({
          data: {
            checkLicense: await restCheckLicense({
              realm: variables.realm,
              environment: variables.environment,
              pipelineId: variables.pipelineId,
              size: variables.size,
              replicas: variables.replicas,
              replicaInstanceName: variables.replicaInstanceName ?? ''
            })
          }
        }),
        staleTime: 0,
        gcTime: 0
      }),
    [queryClient]
  );

  return { checkLicense };
};
